/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetActivitiesQueryResponse,
  GetActivitiesQueryParams,
} from '../models/GetActivities.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  InfiniteData,
  QueryKey,
  QueryClient,
  InfiniteQueryObserverOptions,
  UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { getActivitiesQueryResponseSchema } from '../zod/getActivitiesSchema.ts';
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

export const getActivitiesInfiniteQueryKey = (
  params: GetActivitiesQueryParams,
) => [{ url: '/api/activities' }, ...(params ? [params] : [])] as const;

export type GetActivitiesInfiniteQueryKey = ReturnType<
  typeof getActivitiesInfiniteQueryKey
>;

/**
 * {@link /api/activities}
 */
export async function getActivitiesInfinite(
  params: GetActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/activities`,
    params,
    ...requestConfig,
  });
  return getActivitiesQueryResponseSchema.parse(res.data);
}

export function getActivitiesInfiniteQueryOptions(
  params: GetActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getActivitiesInfiniteQueryKey(params);
  return infiniteQueryOptions<
    GetActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    GetActivitiesQueryResponse,
    typeof queryKey,
    number
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      config.signal = signal;

      if (params) {
        params['PageNumber'] =
          pageParam as unknown as GetActivitiesQueryParams['PageNumber'];
      }
      return getActivitiesInfinite(params, config);
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage['nextPageNumber'],
    getPreviousPageParam: (firstPage) => firstPage['nextPageNumber'],
  });
}

/**
 * {@link /api/activities}
 */
export function useGetActivitiesInfinite<
  TData = InfiniteData<GetActivitiesQueryResponse>,
  TQueryData = GetActivitiesQueryResponse,
  TQueryKey extends QueryKey = GetActivitiesInfiniteQueryKey,
>(
  params: GetActivitiesQueryParams,
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<
        GetActivitiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getActivitiesInfiniteQueryKey(params);

  const query = useInfiniteQuery(
    {
      ...getActivitiesInfiniteQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as InfiniteQueryObserverOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
